import { getList } from '@/api/defaultApi'
import { QUERY_HANDBOOK } from '@/const/query'

const createMutations = () => ({
  SET_STATE_LIST: (state, { key, payload }) => {
    state[key] = [...payload]
  }
})

const createActions = () => ({
  async GETRequest ({ commit }, {
    url,
    keyStateList,
    errorMsg = 'Не удалось загрузить список',
    query = {},
    search = null,
    searchkey = 'all'
  }) {
    try {
      const params = {
        ...QUERY_HANDBOOK,
        ...query
      }

      params[`search[${searchkey}]`] = search

      const response = await getList(url, params)

      commit('SET_STATE_LIST', {
        key: keyStateList,
        payload: response.data?.data || []
      })
    } catch (error) {
      console.error(errorMsg, error)
    }
  }
})

const vuexHandbook = {
  createMutations,
  createActions
}

export {
  vuexHandbook
}
